// Lib
import DefaultHighlight, { inputRegex, pasteRegex } from '@tiptap/extension-highlight';
import { markInputRule, markPasteRule } from '@tiptap/core';

export const TextHighlight = DefaultHighlight.extend({
    // Excluding both means that the highlight won't be applied to coloured text and
    //  multiple highlights also can't be applied to the same text.
    excludes: 'textStyle highlight',

    addKeyboardShortcuts() {
        return {
            'Mod-j': () => this.editor.commands.toggleHighlight({ color: 'green' }),
            'Mod-Shift-h': () => this.editor.commands.toggleHighlight({ color: 'green' }),
        };
    },

    addInputRules() {
        return [
            markInputRule({
                find: inputRegex,
                type: this.type,
                getAttributes: { color: 'green' },
            }),
        ];
    },

    addPasteRules() {
        return [
            markPasteRule({
                find: pasteRegex,
                type: this.type,
                getAttributes: { color: 'green' },
            }),
        ];
    },
}).configure({
    multicolor: true,
});
